<template>
  <div>
    <router-view />
    <Foter />
  </div>
</template>

<script>
import Foter from '@/components/Foter.vue'

export default {
  name: 'App',
  components: {
    Foter
  }
}
</script>

<style>
body {
  font-family: 'Open Sans', sans-serif;
}

</style>
